import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { HelpCircle, LogIn, Mail, X } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";
import { roleDestination } from "@/auth/roleDestination";
import "@/App.css";

export default function LoginPage() {
  const { user, loading, loginWithCredentials } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [showRequest, setShowRequest] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.error) setError(location.state.error);
  }, [location.state]);

  useEffect(() => {
    if (!loading && user) {
      navigate(roleDestination(user.role), { replace: true });
    }
  }, [user, loading, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const result = await loginWithCredentials(username, password);
      navigate(roleDestination(result.role), { replace: true });
    } catch (err) {
      setError(err.response?.data?.detail || "Login gagal.");
    } finally {
      setBusy(false);
    }
  };

  const loginEmergent = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="login-shell">
      <div className="login-hero">
        <div className="login-hero-mark">
          <img src="/logo-padma-transparent.png" alt="Logo PADMA LLDIKTI Wilayah VII" data-testid="login-padma-logo" />
        </div>
        <div className="login-hero-content">
          <h2 data-testid="login-product-name">PADMA</h2>
          <p data-testid="login-product-description">Panel Layanan Administasi Kemahasiswaan</p>
        </div>
        <div className="login-hero-stat">
          <div><span data-testid="login-region-label">LLDIKTI Wilayah <span className="login-hidden-master" data-testid="login-hidden-master" onClick={loginEmergent} role="button" tabIndex={-1} title="">VII</span></span><span>Tim Kerja Kemahasiswaan</span><strong>2026</strong></div>
        </div>
      </div>

      <div className="login-panel">
        <div className="login-card">
          <div className="login-brand">
            <div>
              <p data-testid="login-prompt">Masuk untuk melanjutkan.</p>
            </div>
          </div>

          <form onSubmit={submit} className="login-form" data-testid="credentials-login-form">
            <label>
              <span>Username</span>
              <input type="text" data-testid="login-username" value={username} onChange={(e) => setUsername(e.target.value)} required autoComplete="username" />
            </label>
            <label>
              <span>Password</span>
              <input type="password" data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />
            </label>
            {error && <div className="login-error" data-testid="login-error">{error}</div>}
            <button className="login-submit" data-testid="login-submit" disabled={busy || !username || !password}>
              <LogIn size={16} /> {busy ? "Memproses…" : "Masuk"}
            </button>
          </form>

          <div className="login-footer" style={{ flexDirection: "column", gap: 8 }}>
            <button type="button" className="login-request-link" data-testid="request-account-button" onClick={() => setShowRequest(true)}>
              <HelpCircle size={14} /> Minta Akun PTS
            </button>
          </div>
        </div>
      </div>

      {showRequest && (
        <div className="drawer-backdrop" data-testid="request-account-backdrop" onClick={() => setShowRequest(false)}>
          <div className="request-dialog" data-testid="request-account-dialog" onClick={(e) => e.stopPropagation()}>
            <button className="icon-button" data-testid="request-account-close" aria-label="Tutup" onClick={() => setShowRequest(false)} style={{ position: "absolute", right: 14, top: 14 }}><X size={18} /></button>
            <div className="request-dialog-icon"><Mail size={26} /></div>
            <h3>Cara Meminta Akun PTS</h3>
            <p>Untuk mengajukan akun, silahkan mengirimkan email kepada Tim Kerja Kemahasiswaan melalui email berikut dengan melampirkan surat permohonan dari perguruan tinggi:</p>
            <a className="request-dialog-email" href="mailto:kemahasiswaan.lldikti7@gmail.com" data-testid="request-account-email">
              <Mail size={16} /> kemahasiswaan.lldikti7@gmail.com
            </a>
            <button type="button" className="download-button" style={{ width: "100%", justifyContent: "center", marginTop: 14 }} onClick={() => setShowRequest(false)} data-testid="request-account-ok">
              Mengerti
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
